import { useContext, useEffect } from 'react'
import { AppConfigContext } from '../context/AppConfig'

export function useParentWindowEvent({ onClose = () => {} }) {
  const { exit_intent } = useContext(AppConfigContext)
  useEffect(() => {
    function onParentMessage(event) {
      if (event.data.event === 'close' && exit_intent) {
        onClose()
      }
    }
    // Inside the iframe
    window.addEventListener('message', onParentMessage)
    return () => {
      window.removeEventListener('message', onParentMessage)
    }
  }, [onClose, exit_intent])
}
